import {secured as axios} from "../../../axios";

export class Like {
    static async fetchLikeStatus(contentType,contentId) {
        console.log("fetchLikeStatus");
        const res = await axios.get(`/like-status/${contentType}/${contentId}`);
        return res.data.liked;
    }

    static async fetchLikeCount(contentType,contentId) {
        const res = await axios.get(`/like-count/${contentType}/${contentId}`);
        return res.data.total;
    }

    static async addLike(contentType,contentId) {
        console.log("addLike");
        const res = await axios.post(`/like/${contentId}/${contentType}`);
        return res.status;
    }

    static async removeLike(contentType,contentId) {
        console.log("removeLike");
        const res = await axios.delete(`/dislike/${contentType}/${contentId}`);
        return res.status;
    }
}
